// removed by extract-text-webpack-plugin
module.exports = {"header":"header__header___3b7Ca","title":"header__title___2NyXZ typo__title___2zEbM"};


//////////////////
// WEBPACK FOOTER
// ./components/header/header.css
// module id = 275
// module chunks = 0